import { all, fork } from 'redux-saga/effects';
import { listLabParentResourcesSaga } from './list-lab-parent-resources';
import { refreshSubscriptionsAndLabParentResourcesSaga } from './refresh-subscriptions-and-lab-parent-resources';
export function* rootSaga() {
    yield all([fork(listLabParentResourcesSaga), fork(refreshSubscriptionsAndLabParentResourcesSaga)]);
}
